<template>
    <div class="contract">
        <Header tit="借款合同" color="1"></Header>
        <div class="content" v-html="data.content"></div>
        <div class="content2" v-show="data.content">

            <p>签署时间：{{data.sign_date && new Date(Date.parse(data.sign_date)).toLocaleString('zh-CN')}}</p>
            <p v-if="data.money">借款金额（数字/元）：{{data.money}}</p>
            <p v-if="data.rate">月利率（%）：{{data.rate}}</p>
            <p v-if="data.month">借款期限（月）：{{data.month}}</p>

            <p>手机号：{{data.mobile}}</p>
            <p>证件号：{{data.id_card_num}}</p>


            <p>甲方签名：</p>
            <img :src="$ht_ip + data.sign_img_url" alt="">
            
            <p>出借公司签章：</p>

              <div class="seal">
                <img :src="data.seal" >
            </div>

        </div>
    </div>
</template>
<script>
import Header from "../public/header";
export default {
    components: { Header },
    data(){
        return{
            data:{}
        }
    },
    mounted(){
        this.get_data();
    },
    methods:{
        get_data(){
            this.$get(this.$path.contact).then(res => {
                if (res.success) {
                    this.data = res.data;
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.contract{
    .content2{
        margin-top:1rem;
        p{
            color: red;
            margin-bottom: .1rem;
        }
    }
    .seal{
        position: relative;
        img{
            position:absolute;
            right:0;
            height: 6.6rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/my/contract.vue